import { render, staticRenderFns } from "./UserFilter.vue?vue&type=template&id=b3581c76&"
import script from "./UserFilter.vue?vue&type=script&lang=ts&"
export * from "./UserFilter.vue?vue&type=script&lang=ts&"
import style0 from "./UserFilter.vue?vue&type=style&index=0&id=b3581c76&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports